import { WAC_URL, SAC_URL } from './constants';
import getLanguageFromMetaTag from '../../common/localization-utils';

const languagePathMap: { [key: string]: string } = {
    'ja-JP': '/ja'
};

const supportedDomains = new Set([WAC_URL, SAC_URL]);

export const getLocalizedUrl = (baseUrl: string, path: string) => {
    const language = getLanguageFromMetaTag();
    const localizedPathPrefix = (language && languagePathMap[language]) || '';

    return `${baseUrl}${localizedPathPrefix}${path}`;
};

export const getLocalizedHref = (href: string) => {
    if (!href) {
        return href;
    }

    const url = new URL(href, 'https://relative');
    const isRelative = url.origin === 'https://relative';

    if (!isRelative && !supportedDomains.has(url.origin)) {
        return href;
    }

    const basePath = isRelative ? '' : url.origin;

    return getLocalizedUrl(basePath, url.pathname + url.search + url.hash);
};
